import HarvestCard from './HarvestCard';

export default HarvestCard;
